import { Pipe, PipeTransform } from '@angular/core';
import { AlarisLanguageService } from '@campaign-portal/components-library';

const DELETED_LABEL = '(deleted)';

@Pipe({
	name: 'contactUser',
	pure: false,
	standalone: true,
})
export class ContactUserPipe implements PipeTransform {
	constructor(private readonly ls: AlarisLanguageService) {}

	transform(user: string): string {
		return user.endsWith(DELETED_LABEL) ? user.replace(DELETED_LABEL, this.ls.translate('contacts.deleted')) : user;
	}
}
